/**
 * Events used in the landcare-toolkit
 */
export let Events = {
    'OL_RESET_EXTENT': 'ol-reset-extent'
};
